var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-3" }, [
    _c("div", { class: { "has-crossprice": _vm.hasCrossPrice } }, [
      _c("span", { staticClass: "price h1 d-inline-block pr-3" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm._f("currency")(
                _vm.variationTotalPrice,
                _vm.variation.prices.default.currency
              )
            ) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "vat small" },
        [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.isExportDelivery
                  ? ""
                  : _vm.$translate("Ceres::Template.singleItemInclVAT")
              ) +
              "\n      "
          ),
          !_vm.hasFreeShipping
            ? [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$translate("Ceres::Template.singleItemExclusive")
                    ) +
                    "\n        "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      "data-toggle": "modal",
                      href: "#shippingscosts",
                      title: _vm.$translate(
                        "Ceres::Template.singleItemShippingCosts"
                      ),
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$translate(
                          "Ceres::Template.singleItemShippingCosts"
                        )
                      )
                    ),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _vm.hasCrossPrice
      ? _c("div", { staticClass: "crossprice d-flex" }, [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$translate("modeherz::SingleItemPageClient.itemPageRRP")
              ) +
              ":\n    "
          ),
          _c("del", { staticClass: "pl-1" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm._f("itemCrossPrice")(
                    _vm.variation.prices.rrp.unitPrice.formatted
                  )
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "calculated" }, [
            _vm._v("\n       / "),
            _c("b", [
              _vm._v(
                _vm._s(
                  _vm.$translate(
                    "modeherz::SingleItemPageClient.itemPagePriceYouSave"
                  )
                ) + " "
              ),
            ]),
            _c("span", [
              _vm._v(" - " + _vm._s(_vm.youSaveAmountText) + "\n      "),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.variation.prices.default.lowestPrice &&
    _vm.variation.prices.default.lowestPrice.value &&
    _vm.hasCrossPrice &&
    _vm.displayLowestPrice
      ? _c("div", { staticClass: "lowest-price text-muted mb-3" }, [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$translate("Ceres::Template.singleItemLowestPrice", {
                  price: _vm.variation.prices.default.lowestPrice.formatted,
                })
              ),
            },
          }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }